export const EqualProminenceMobileSites = [
  'AU',
  'CA',
  'ES',
  'CA',
  'FR',
  'GB',
  'IT',
  'PT',
  'UK',
  'US',
  'GOFR',
  'OPGB',
  'OPFR',
  'OPUK',
];

export const isEqualProminenceMobileBySite = (site: string): boolean =>
  EqualProminenceMobileSites.includes(site);
